import type { WorkCondition } from "@/types/work.types";
import { formatWorkPrice } from "./work-price";

export type WorkConditionAvailability =
  | "available"
  | "cross-format-fallback"
  | "unavailable";

/**
 * Legacy keeps a missing condition clickable when its SKU identity points to
 * a replacement in another format. A condition without any SKU identity has
 * no replacement and must remain disabled.
 * @param condition Work condition resolved by the backend selector.
 * @returns The availability state used by the copy selector.
 */
export const getWorkConditionAvailability = (
  condition: WorkCondition,
): WorkConditionAvailability => {
  if (!condition.idIq) return "unavailable";
  if (condition.idMedia !== condition.bindingIdMedia) {
    return "cross-format-fallback";
  }
  return "available";
};

/**
 * Formats the secondary line shown in a condition selector button.
 * @param condition Work condition represented by the button.
 * @returns A price or the appropriate Legacy-compatible availability label.
 */
export const formatWorkConditionSelectionPrice = (
  condition: WorkCondition,
): string => {
  const availability = getWorkConditionAvailability(condition);
  if (availability === "available") return formatWorkPrice(condition.price);
  if (availability === "unavailable") return "Unavailable";
  return "Out of stock";
};
